import { markRaw } from 'vue';
import KoelncongressLogo from '../Icon/KoelncongressLogo.vue';
import KoelnmesseLogo from '../Icon/KoelnmesseLogo.vue';

export const COMPANY_GROUP_PRESETS = [
    {
        value: 'Koelnmesse GmbH',
        label: 'Koelnmesse GmbH',
        icon: markRaw(KoelnmesseLogo),
        iconClass: 'h-4.5',
        selectedClass: 'bg-koelnmesse',
    },
    {
        value: 'Koelncongress GmbH',
        label: 'Koelncongress GmbH',
        icon: markRaw(KoelncongressLogo),
        iconClass: 'h-4',
        selectedClass: 'bg-koelnmesse',
    },
];
